var angular = require('angular');
var _module = require('./module');
var config = require('config');
var _ = require('lodash');
var $ = require('jquery');

require('../services/analytics');
require('./config');
require('../services/raygun');
require('angular-material');
require('../services/user');
require('../services/analytics');
require('../services/activate-device-modal');
require('./header');
require('./footer');
require('./third-party/angular-sanitize');
require('./branded-sidenav');

_module.requires.push('ngMaterial', 'ngSanitize');

_module.controller('ApplicationCtrl', [
    '$log',
    '$scope',
    '$rootScope',
    '$timeout',
    '$state',
    '$user',
    'User',
    '$analytics',
    'localStorageService',
    '$activateDeviceModal',
    '$raygun',

    function applicationCtrl($log, $scope, $rootScope, $timeout, $state, $user, User, $analytics, localStorageService, $activateDeviceModal, $raygun) {
        $log.debug('ApplicationCtrl');

        var initStateData = function () {
            $scope.showHeaderBg = false;
            $scope.headerClass = undefined;
            $scope.footerClass = undefined;
            $scope.hideHeader = false;
        };

        var init = function () {
            initStateData();
        };

        init();

        if(window) {
            window.onbeforeunload = function (ev) {
                if(localStorageService.get('userCurrentState')){
                    localStorageService.remove('userCurrentState');
                }
            };
        }


        ///////////////////
        // Branded Side Nav
        ///////////////////
        $scope.brandedSidenavIsOpen = false;

        $scope.$watch(function () { return $scope.brandedSidenavIsOpen; }, function (value) {
            if(value) {
                $timeout(function () {
                    $('.homepage-branded-sidenav').scrollTop(0);
                });

                $('.root-wrapper').css({
                    overflow: 'hidden',
                    position: 'relative',
                    height: '100%',
                    display: 'block'
                });
            } else {
                $('.root-wrapper').css({
                    overflow: '',
                    position: '',
                    height: '',
                    display: ''
                });
            }
        });

        ///////////////////
        // User Stuff
        ///////////////////
        $scope.isAttemptingLogin = true;

        $scope.$watch(function () { return $user.isLoggedIn; }, function watchIsLoggedIn(value) {
            $log.debug('user', $user);

            if(value) {
                if($user.phone) {
                    // Raygun
                    $raygun.setUser(
                        $user.email,
                        false,
                        $user.email,
                        $user.first_name + ' ' + $user.last_name,
                        $user.first_name,
                        $user.id
                    );

                    // Analytics
                    var mpData = {
                        'Consumer ID': $user.id,
                        'Consumer Name': $user.first_name + ' ' + $user.last_name,
                        'Consumer Email': $user.email,
                        'Consumer Phone': $user.phone,
                        'Referral Code': $user.refCodeId
                    };

                    $analytics.setSuperProperties(mpData);
                    $analytics.setUsername($user.id);
                    $analytics.setUserProperties({
                        $email: $user.email,
                        $name: $user.full_name,
                        $created: $user.createdAt,
                        $last_login: new Date(),
                        $phone: $user.phone,
                        'Account Type': $user.account_type,
                        'Affiliate Id': $user.affiliateId,
                        'Affiliate Code': _.get($user, 'affiliate.affiliate_code'),
                        'Nest User': true
                    });
                }
            }

            $scope.$watch(function () { return $user.refCodeId; }, function onRefCodeChange(value) {
                if(value) {
                    $analytics.setSuperProperties({ 'Referral Code': value });
                }
            });
        });

        $scope.$watch(function () { return $user.attemptedLogin; }, function watchAttemptingLogin(attemptedLogin) {
            $log.debug('attemptedLogin', attemptedLogin);

            if(attemptedLogin) {
                $scope.isAttemptingLogin = false;
            } else {
                $scope.isAttemptingLogin = true;
            }
        }, true);

        $scope.$watch(function () { return $user.affiliate; }, function watchUserAffiliate(value) {
            if(value) {
                var mpData = {
                    'Affiliate ID': $user.affiliate.id,
                    'Affiliate Code': $user.affiliate.affiliate_code,
                    'Affiliate Name': $user.affiliate.first_name + ' ' + $user.affiliate.last_name,
                    'Affiliate Email': $user.affiliate.email,
                    'Affiliate Phone': $user.affiliate.phone,
                    'Affiliate Company': $user.affiliate.company
                };

                if($user.affiliate.benoit_partner) {
                    mpData['Vendor User ID'] = $user.affiliate.benoit_partner.id;
                    mpData['Vendor User Name'] = $user.affiliate.benoit_partner.first_name + ' ' + $user.affiliate.benoit_partner.last_name;
                    mpData['Vendor User Email'] = $user.affiliate.benoit_partner.email;
                    mpData['Vendor User Phone'] = $user.affiliate.benoit_partner.phone;
                    mpData['Vendor User Company'] = $user.affiliate.benoit_partner.company;
                }

                $analytics.setSuperProperties(mpData);
            }
        }, true);

        ////////////////////
        // EVENT HANDLERS //
        ////////////////////

        var updateStateData = function (stateData) {
            if( stateData &&
                stateData.layout ){
                $scope.showHeaderBg = !!stateData.layout.showHeaderBg;
                $scope.hideHeader = !!stateData.layout.hideHeader;
                $scope.hideHeaderLinks = !!stateData.layout.hideHeaderLinks;
                $scope.showListReportsLogo = !!stateData.layout.showListReportsLogo;

                if( angular.isDefined(stateData.layout.headerClass) &&
                    stateData.layout.headerClass.length ){
                    $scope.headerClass = stateData.layout.headerClass;
                }

                if( angular.isDefined(stateData.layout.footerClass) &&
                    stateData.layout.footerClass.length ){
                    $scope.footerClass = stateData.layout.footerClass;
                }
            }
        };

        // manipulate layout based on rules in state config
        $rootScope.$on('$stateChangeSuccess',
            function (event, toState, toParams, fromState, fromParams){
                initStateData();
                var currState = $state.current || {};
                if(currState && currState.data){
                    updateStateData(currState.data);
                }
            }
        );

        $rootScope.$on(User.LOGGED_IN, function onLogin(e, userData) {
            var mpData = {
                'Consumer ID': userData.id,
                'Consumer Name': userData.first_name + ' ' + userData.last_name,
                'Consumer Email': userData.email,
                'Consumer Phone': userData.phone
            };

            $analytics.setSuperProperties(mpData);
            $analytics.setUsername(userData.id);
            $analytics.eventTrack('Nest User Logged In');
        });

        $rootScope.$on(User.SHOW_ACTIVATE_DEVICE_MODAL, function () {
            $activateDeviceModal();
        });
    }
]);
